export enum EMovementType {
  GOAL = 'GOAL',
  PRESALE = 'MATCH_PRESALE',
  COUPON = 'COUPON_PRESALES',
  GOLCOIN = 'GOLCOIN',
  FREE = 'FREE',
}
